module.exports = __webpack_public_path__ + "img/ua.30a00521.svg";